"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DescendantManager = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _isFunction = require("./isFunction");
var DescendantManager = exports.DescendantManager = exports.default = /*#__PURE__*/(0, _createClass2.default)(function DescendantManager(_ref) {
  var _this = this;
  var trapNode = _ref.trapNode,
    getDescendantNodes = _ref.getDescendantNodes,
    getActiveDescendantNode = _ref.getActiveDescendantNode,
    firstKeyCode = _ref.firstKeyCode,
    previousKeyCode = _ref.previousKeyCode,
    nextKeyCode = _ref.nextKeyCode,
    lastKeyCode = _ref.lastKeyCode,
    pageUpKeyCode = _ref.pageUpKeyCode,
    pageDownKeyCode = _ref.pageDownKeyCode,
    ignoreFirstAndLastKeys = _ref.ignoreFirstAndLastKeys,
    stepValue = _ref.stepValue,
    stopKeyPressPropagation = _ref.stopKeyPressPropagation,
    onActiveDescendantChange = _ref.onActiveDescendantChange;
  (0, _classCallCheck2.default)(this, DescendantManager);
  (0, _defineProperty2.default)(this, "detach", function () {
    document.removeEventListener('keydown', _this.keyHandler);
  });
  (0, _defineProperty2.default)(this, "updateDescendantNodes", function () {
    _this.descendantNodes = _this.getDescendantNodes();
  });
  (0, _defineProperty2.default)(this, "updateActiveDescendant", function (fn) {
    _this.activeDescendant = (0, _isFunction.isFunction)(fn) ? fn() : null;
  });
  (0, _defineProperty2.default)(this, "getIsFirstKey", function (event) {
    return event.keyCode === _this.firstKeyCode;
  });
  (0, _defineProperty2.default)(this, "getIsPreviousKey", function (event) {
    var _context;
    return (0, _includes.default)(_context = _this.previousKeyCode).call(_context, event.keyCode);
  });
  (0, _defineProperty2.default)(this, "getIsNextKey", function (event) {
    var _context2;
    return (0, _includes.default)(_context2 = _this.nextKeyCode).call(_context2, event.keyCode);
  });
  (0, _defineProperty2.default)(this, "getIsLastKey", function (event) {
    return event.keyCode === _this.lastKeyCode;
  });
  (0, _defineProperty2.default)(this, "getIsPageUpKey", function (event) {
    return event.keyCode === _this.pageUpKeyCode;
  });
  (0, _defineProperty2.default)(this, "getIsPageDownKey", function (event) {
    return event.keyCode === _this.pageDownKeyCode;
  });
  (0, _defineProperty2.default)(this, "keyHandler", function (e) {
    if (!document.body.contains(_this.container)) {
      document.removeEventListener('keydown', _this.keyHandler);
      return;
    }

    // first and last keys are only captured for standalone components
    var isFirstKey = !_this.ignoreFirstAndLastKeys && _this.getIsFirstKey(e);
    var isPreviousKey = _this.getIsPreviousKey(e);
    var isNextKey = _this.getIsNextKey(e);
    var isLastKey = !_this.ignoreFirstAndLastKeys && _this.getIsLastKey(e);
    var isPageUpKey = _this.getIsPageUpKey(e);
    var isPageDownKey = _this.getIsPageDownKey(e);
    if (isFirstKey || isPreviousKey || isNextKey || isLastKey || isPageUpKey || isPageDownKey) {
      e.preventDefault();
      if (_this.stopKeyPressPropagation) {
        e.stopPropagation();
      }
      _this.updateDescendantNodes();
      var currentIndex = _this.descendantNodes.indexOf(_this.activeDescendant);
      var lastNode = _this.descendantNodes[_this.descendantNodes.length - 1];
      var firstNode = _this.descendantNodes[0];
      if (isFirstKey) {
        _this.setActiveDescendant(e, firstNode);
      } else if (isPreviousKey) {
        if (currentIndex === -1) {
          _this.setActiveDescendant(e, firstNode);
        } else if (_this.descendantNodes[currentIndex] === firstNode) {
          if (_this.ignoreFirstAndLastKeys) {
            _this.setActiveDescendant(e, lastNode);
          }
        } else {
          _this.setActiveDescendant(e, _this.descendantNodes[currentIndex - 1]);
        }
      } else if (isNextKey) {
        if (currentIndex === -1) {
          _this.setActiveDescendant(e, firstNode);
        } else if (_this.descendantNodes[currentIndex] === lastNode) {
          if (_this.ignoreFirstAndLastKeys) {
            _this.setActiveDescendant(e, firstNode);
          }
        } else {
          _this.setActiveDescendant(e, _this.descendantNodes[currentIndex + 1]);
        }
      } else if (isLastKey) {
        _this.setActiveDescendant(e, lastNode);
      } else if (isPageDownKey) {
        if (currentIndex === -1) {
          _this.setActiveDescendant(e, firstNode);
        } else if (currentIndex + _this.stepValue >= _this.descendantNodes.length - 1) {
          _this.setActiveDescendant(e, lastNode);
        } else {
          _this.setActiveDescendant(e, _this.descendantNodes[currentIndex + _this.stepValue]);
        }
      } else if (isPageUpKey) {
        if (currentIndex === -1) {
          _this.setActiveDescendant(e, firstNode);
        } else if (currentIndex <= _this.stepValue) {
          _this.setActiveDescendant(e, firstNode);
        } else {
          _this.setActiveDescendant(e, _this.descendantNodes[currentIndex - _this.stepValue]);
        }
      }
    }
  });
  (0, _defineProperty2.default)(this, "setActiveDescendant", function (e, node) {
    if (node) {
      var previousActiveDescendant = _this.activeDescendant;
      _this.activeDescendant = node;
      _this.onActiveDescendantChange(e, node, previousActiveDescendant);
    }
  });
  this.pageDownKeyCode = pageDownKeyCode || _keycode.default.codes.pgdn;
  this.pageUpKeyCode = pageUpKeyCode || _keycode.default.codes.pgup;
  this.container = trapNode;
  this.firstKeyCode = firstKeyCode || _keycode.default.codes.home;
  this.previousKeyCode = previousKeyCode || [_keycode.default.codes.up];
  if (!Array.isArray(this.previousKeyCode)) {
    this.previousKeyCode = [this.previousKeyCode];
  }
  this.nextKeyCode = nextKeyCode || [_keycode.default.codes.down];
  if (!Array.isArray(this.nextKeyCode)) {
    this.nextKeyCode = [this.nextKeyCode];
  }
  this.lastKeyCode = lastKeyCode || _keycode.default.codes.end;
  this.ignoreFirstAndLastKeys = !!ignoreFirstAndLastKeys;
  this.stepValue = stepValue || 5;
  this.stopKeyPressPropagation = !!stopKeyPressPropagation;
  this.onActiveDescendantChange = (0, _isFunction.isFunction)(onActiveDescendantChange) ? onActiveDescendantChange : function () {};
  this.getDescendantNodes = (0, _isFunction.isFunction)(getDescendantNodes) ? getDescendantNodes : function () {
    return [];
  };
  this.updateDescendantNodes();
  if ((0, _isFunction.isFunction)(getActiveDescendantNode)) {
    this.activeDescendant = getActiveDescendantNode();
  }
  document.addEventListener('keydown', this.keyHandler);
});